import copy from './uiCopy.json';
import { SOURCE_LOCALE } from './apply';

const EN = copy.en;

export type UiKey = keyof typeof EN;

function isStringRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function uiString(locale: string, key: UiKey): string {
    const fallback = EN[key];
    if (locale === SOURCE_LOCALE) return fallback;
    const pack = (copy as Record<string, unknown>)[locale];
    if (!isStringRecord(pack)) return fallback;
    const value = pack[key];
    return typeof value === 'string' && value.trim().length > 0 ? value : fallback;
}

export function uiTemplate(
    locale: string,
    key: UiKey,
    params: Record<string, string>
): string {
    return Object.entries(params).reduce(
        (text, [token, value]) => text.split(`{${token}}`).join(value),
        uiString(locale, key)
    );
}
